import { render, staticRenderFns } from "./ContactCard.vue?vue&type=template&id=2cf1b642&scoped=true&"
import script from "./ContactCard.vue?vue&type=script&lang=js&"
export * from "./ContactCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cf1b642",
  null
  
)

export default component.exports